export default {"src":"/polygon/_next/static/media/immuneBytes.38b54899.svg","height":88,"width":88};